<template>
  <div class="list-field-name row g-2">
    <div
      class="row center middle list-field-name__thumbnail"
      :style="'aspect-ratio: 3/2; width: 6rem; background-color: #eaeaea;'"
    >
      <ImageComponent v-if="thumbnail" v-bind="thumbnail" />
      <FontAwesomeIcon v-else :icon="['fal', 'drafting-compass']" size="lg" />
    </div>
    <div class="col center list-field-name__content">
      <div class="row g-1 middle">
        <strong>{{ item.name }}</strong>
        <img v-if="language" v-bind="language" />
      </div>
      <span v-if="item.sublabel" class="list-field-name__sublabel" :title="item.sublabel">{{ item.sublabel }}</span>
      <StatusIndicator v-if="!hideStatus" v-bind="status" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Languages } from '@/components/User/Language'

import ImageComponent from '@/components/Image'
import StatusIndicator from '@/components/StatusIndicator.vue'
import { thumbhashToBase64 } from '@/utils/thumbhash'
import getCoverThumbnail from '@/utils/getCoverThumbnail'

export default {
  props: {
    item: Object,
    hideStatus: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      defaultLanguage: ({ enums = {} }) =>
        ((enums.Languages || []).find(({ default: isDefault }) => Boolean(isDefault)) || {}).value,
    }),
    thumbnail() {
      const items = this.$path('item.media.cover') || this.$path('item.cover') || []
      const src = getCoverThumbnail(items)
      if (!src) return

      const image = items.find(({ url }) => url === src)
      return {
        src,
        alt: this.item.name,
        style: `border-radius: var(--border-radius); aspect-ratio: 3/2; width: 6rem;`,
        preview: image ? thumbhashToBase64(image) : null,
      }
    },
    language() {
      const lang = this.$path('item.metadata.language')
      if (lang === this.defaultLanguage || !(lang in Languages)) return

      return { alt: Languages[lang], src: `/images/flags/${lang}.svg`, width: 15 }
    },
    status() {
      if (this.item.isArchived) return { label: this.$t('archived'), status: 'warning' }
      if (this.item.isPublished) return { label: this.$t('published'), status: 'success' }
      return { label: this.$t('unpublished'), status: 'error' }
    },
  },
  components: {
    ImageComponent,
    StatusIndicator,
  },
}
</script>

<style lang="scss">
.list-field-name__sublabel {
  display: block;
  max-width: 22ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
